module.exports = __webpack_public_path__ + "img/icon-excel.4d39db0e.svg";